import React from 'react';

export default function JazzCup() {
	return (
		<g>
			<ellipse fill="#ebefff" cx="98.55396" cy="313.54935" rx="37.61078" ry="9.44258" />
			<ellipse fill="#fb9f59" cx="98.55396" cy="320.43338" rx="35.77922" ry="8.98275" />
			<path fill="#FFFFFF" d="M98.55383,322.99191c-20.60988,0-37.33862-4.16248-37.59834-9.32135h-0.01234l9.17892,76.41412
				c0,3.25748,8.68463,9.75937,28.43177,9.75937c19.74691,0,28.43201-6.44443,28.43201-9.70193l9.17891-76.47156h-0.0121
				C135.89293,318.82944,119.16395,322.99191,98.55383,322.99191z" />
			<g opacity="0.6">
				<path fill="#FFFFFF" d="M119.7729,280.51514c0.08665-0.66141-1.88027-1.46387-4.39301-1.79221
					c-2.47118-0.32309-4.55396-0.06693-4.704,0.5705c0,0-4.81226,37.27051-4.81226,37.33911
					c0,0.54913,2.09655,0.99451,4.68264,0.99451c2.58632,0,4.68288-0.44537,4.68288-0.99451
					c0-0.00024-0.00024-0.00024-0.00024-0.00024C115.22986,316.62589,119.74702,280.71338,119.7729,280.51514z" />
			</g>
			<path fill="#f8faff" d="M98.55407,301.18954c-15.05287,0-40.52821,2.60318-40.52821,12.35971c0,0,0.70065,5.32193,0.72878,5.54385
				c1.14868,9.06424,25.35516,11.50989,39.79943,11.50989c14.50479,0,38.85357-2.46619,39.81242-11.62421
				c0.01938-0.18506,0.71555-5.42953,0.71555-5.42953C139.08203,303.79272,113.60693,301.18954,98.55407,301.18954z
				M98.55407,322.01871c-20.77204,0-35.52506-3.2562-35.66453-8.46945c-0.1148-4.29138,14.89249-8.46924,35.66453-8.46924
				c20.7718,0,35.77912,4.17786,35.66428,8.46924C134.07884,318.76251,119.32587,322.01871,98.55407,322.01871z" />
			<path fill="#00DBD5" d="M131.36719,353.63913l-16.97949-17.32996c-2.21094-2.25684-5.64941-2.7749-8.42383-1.27246
				c-2.77832,1.50195-4.22461,4.66211-3.54688,7.74658l3.29297,14.98438l-19.92773-21.33594
				c-2.18457-2.33936-5.66699-2.92334-8.49414-1.42041c-2.82715,1.50098-4.29492,4.7124-3.58008,7.83203l3.39746,14.84277
				l-12.4624-13.21338l2.84058,23.64795l17.18042,18.21582c2.19141,2.32324,5.66602,2.89307,8.48633,1.38672
				c2.81738-1.50488,4.27734-4.70996,3.56543-7.82373l-3.3418-14.59619l19.62109,21.00781
				c2.17578,2.33008,5.64355,2.91699,8.4668,1.43506c2.82324-1.48389,4.30566-4.67188,3.62109-7.78662l-3.54199-16.11816
				l7.66309,7.82098L131.36719,353.63913z" />
			<path fill="#987FEF" d="M130.71802,359.0488l-17.63208-4.27234c-0.61133-0.14648-1.25293,0.12207-1.57422,0.66797
				c-0.32031,0.54492-0.24512,1.23535,0.18457,1.69971l8.03516,8.68018L76.2832,354.78036
				c-0.625-0.15771-1.27051,0.11572-1.59277,0.66943c-0.32227,0.5542-0.2373,1.25439,0.20703,1.71533l8.32031,8.62891
				l-16.5127-4.15649l0.36621,3.04858l20.30957,5.1123c0.62012,0.15625,1.26855-0.11768,1.58984-0.67139
				s0.23633-1.25293-0.20801-1.71387l-8.30566-8.61328l43.2666,10.99805c0.62305,0.1582,1.26172-0.11084,1.58594-0.65674
				c0.32422-0.54639,0.25098-1.24072-0.18066-1.70703l-8.10156-8.75195l13.34644,3.23395L130.71802,359.0488z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/JazzCup.js